import { get } from "./api";

export const getMapAssets = () => {
  return get("/api/v2/map_assets");
};

export const getMapAsset = (slug: string) => {
  return get(`api/v2/map_assets/${slug}`);
};
